const initialState = () => ({
  contacts: [],
  contacts_page: 1,
  contacts_pages_total: 0,
})

export default initialState
